export default "__VITE_ASSET__BMCNT8Ct__"